import React from "react";

const PrivacyPolicy = () => (
  <div className="max-w-4xl mx-auto p-6 font-sans">
    <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">Privacy Policy</h1>
    
    <div className="space-y-6">
      <p className="text-gray-700 leading-relaxed">
        At <strong>JR Home Foods</strong>, we are committed to protecting your personal information and your right to privacy. 
        This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
      </p>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">1. Information We Collect</h2>
        <p className="text-gray-700 mb-3">We collect the following types of personal information:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li><strong>Name</strong></li>
          <li><strong>Contact Information</strong> (Phone number, Email address)</li>
          <li><strong>Delivery Address</strong></li>
          <li><strong>Payment Information</strong> (Processed securely via our payment gateway – we do not store card or UPI data)</li>
          <li><strong>Device and Usage Information</strong> (Automatically collected)</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">2. How We Use Your Information</h2>
        <p className="text-gray-700 mb-3">We use your information to:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Process and fulfill your orders</li>
          <li>Facilitate secure online payments via our payment gateway</li>
          <li>Communicate order updates and customer service messages</li>
          <li>Improve our services and user experience</li>
          <li>Comply with legal and financial regulations</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">3. Sharing of Information</h2>
        <p className="text-gray-700 mb-3">We do <strong>not</strong> sell or rent your personal data.</p>
        <p className="text-gray-700 mb-3">Your data is only shared with:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li><strong>Payment Gateway</strong> (for payment processing)</li>
          <li><strong>Delivery Partners</strong> (to fulfill your orders)</li>
          <li><strong>Authorized legal or government entities</strong>, when required by law</li>
        </ul>
        <p className="text-gray-700 mt-3">
          All third-party service providers are bound by strict confidentiality agreements and data protection policies.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">4. Payment Processing</h2>
        <p className="text-gray-700 mb-3">
          We use a trusted payment gateway for secure transactions. All payment transactions are encrypted and securely processed.
        </p>
        <p className="text-gray-700 mb-3">
          Our payment gateway may collect and process your payment details in accordance with their privacy policy.
        </p>
        <p className="text-gray-700">
          We do not store your card, UPI, or other sensitive payment information.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">5. Data Retention</h2>
        <p className="text-gray-700">
          We retain your data only for as long as necessary to provide our services and comply with legal obligations. 
          You can request deletion of your data by contacting us.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">6. Cookies and Tracking</h2>
        <p className="text-gray-700">
          We may use cookies or tracking tools to enhance user experience and monitor site traffic. 
          You can disable cookies in your browser settings.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">7. Your Rights</h2>
        <p className="text-gray-700 mb-3">You have the right to:</p>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Access, correct, or delete your data</li>
          <li>Withdraw consent at any time</li>
          <li>Contact us with any privacy concerns</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">8. Contact Us</h2>
        <p className="text-gray-700 mb-3">If you have any questions about this Privacy Policy, please contact:</p>
        <div className="bg-green-50 p-4 rounded-lg">
          <p className="font-semibold text-green-800 mb-2">JR Home Foods</p>
          <div className="space-y-1 text-gray-700">
            <p>📞 Phone: 7893816225</p>
            <p>📧 Email: help.jrhomefoods@gmail.com</p>
            <p>📍 Address: Beerumguda, Hyderabad</p>
            <p>🌐 Website: <a href="https://jrhomefoods.com" className="text-green-600 hover:text-green-800 underline" target="_blank" rel="noopener noreferrer">https://jrhomefoods.com</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy; 